import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectOneSettingsQueryItems } from '../../../../../redux/one-settings/selector';
import { oneSettings } from '../../../../../redux/one-settings/action';
import { OneSettingsComponent } from '../components/one.component';

const OneSettings = () => {
  const dispatch = useAppDispatch()
  const oneSettingsQuery = useSelector(selectOneSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectOneSettings, setSelectOneSettings] = useState<any>([])

  const fetchOneSettingsQueryById = () => {
    dispatch(oneSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/one/query`,
      entity: 'oneSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectOneSettings({ ...selectOneSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchOneSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectOneSettings(oneSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(oneSettings.resetAction({ actionType: 'update' }))
    await dispatch(oneSettings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/one`,
      entity: 'oneSettings',
      jsonData: {
        Records: [
          selectOneSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <OneSettingsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectOneSettings={selectOneSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default OneSettings;